import React, { useContext, useState, useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { ResponsiveContext, Layer, Spinner, Page, PageContent, PageHeader, Text, Box, Button, Grid } from 'grommet'
import { useParams } from "react-router-dom";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ReverseAnchor } from '../components/competetive/ReverseAnchor';
import { storageActions } from '../redux/actions';
import { storageService } from '../services/storage';
import { ApplicationPrimariesGrid } from '../components/storage/ApplicationPrimariesGrid';
import { CustomCard } from '../components/competetive/CustomCard';
import { storageAdminService } from '../services';

function ApplicationPrimaryListPage({ props }) {
    const size = useContext(ResponsiveContext);
    const dispatch = useDispatch();
    const { id, name } = useParams();

    const session = useSelector((state) => {
        return state.session;
    });
    const [selectedApplication, setSelectedApplication] = useState()
    useEffect(() => {
        if (session && session.user && session.user.access) {
            dispatch(storageActions.getPrimariesForApplication(session.user.access, id));
            storageService.getApplicationById(session.user.access, id).then((response) => setSelectedApplication(response.application_name))
        }
    }, [session, id, dispatch]);


    const applicationPrimaries = useSelector((state) => {
        return state.storageApplication.primaries
    });
    const history = useHistory();
    const [isUserApplicationAdmin, setIsUserApplicationAdmin] = useState(false)
    useEffect(() => {
        storageAdminService.isUserInAdminGroup(session.user.access, id).then((response) => {
            if (response.is_member) {
                setIsUserApplicationAdmin(response.is_member)
            }
            else {
                setIsUserApplicationAdmin(false)
            }
        })
    }, [id, session])
    return (
        <>
            <Page>
                <PageContent gap='medium'>
                    {
                        applicationPrimaries.requestInProgress && (<Layer position='center' background='none' style={{ boxShadow: "none" }}>
                            <Spinner />
                        </Layer>)}
                    {applicationPrimaries.data && applicationPrimaries.data.length > 0 ?
                        <>
                            <PageHeader parent={<ReverseAnchor label={"Applications"} onClick={() => { window.history.go(-1) }} />} title={selectedApplication}
                            />
                            {
                                <ApplicationPrimariesGrid productsList={applicationPrimaries.data} competitorId={id} history={history} size={size} applicationId={id} />

                            }
                        </> : <>
                            <Box align='center' pad={"large"}>
                                <Text alignSelf='center'>No Data yet...</Text>
                            </Box>
                            <Grid
                                columns={"20%"} gap={"medium"}
                                rows={[["auto", "full"]]}
                                pad='medium'
                                fill
                            >
                                {session.user && session.user.user && session.user.user.user_role && session.user.user.user_role.role_name && session.user.user.user_role.role_name.toString().startsWith('Admin') && isUserApplicationAdmin &&
                                    <>
                                        <CustomCard title={"Admin"} description={"Customize your application"} onClickHandler={() => {
                                            history.push(`/storage-admin-dash/${id}`)
                                        }} />
                                    </>
                                }
                            </Grid>

                        </>
                    }
                </PageContent>
            </Page>
        </>
    )
}

export default ApplicationPrimaryListPage